export default function optimizeRender() {
  if (global.dataLayer) {
    global.dataLayer.push({ event: 'optimize.activate' });
  }
}
